/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilterLogicalOperator,
    FilterLogicalOperatorFromJSON,
    FilterLogicalOperatorFromJSONTyped,
    FilterLogicalOperatorToJSON,
    SortingDto,
    SortingDtoFromJSON,
    SortingDtoFromJSONTyped,
    SortingDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetRolePermissionRelationsQuery
 */
export interface GetRolePermissionRelationsQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetRolePermissionRelationsQuery
     */
    permissions?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetRolePermissionRelationsQuery
     */
    roleId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetRolePermissionRelationsQuery
     */
    page?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetRolePermissionRelationsQuery
     */
    pageSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetRolePermissionRelationsQuery
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRolePermissionRelationsQuery
     */
    take?: number;
    /**
     * 
     * @type {FilterLogicalOperator}
     * @memberof GetRolePermissionRelationsQuery
     */
    filterLogicalOperator?: FilterLogicalOperator;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetRolePermissionRelationsQuery
     */
    filterKeys?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SortingDto>}
     * @memberof GetRolePermissionRelationsQuery
     */
    sortings?: Array<SortingDto> | null;
}

export function GetRolePermissionRelationsQueryFromJSON(json: any): GetRolePermissionRelationsQuery {
    return GetRolePermissionRelationsQueryFromJSONTyped(json, false);
}

export function GetRolePermissionRelationsQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRolePermissionRelationsQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'filterLogicalOperator': !exists(json, 'filterLogicalOperator') ? undefined : FilterLogicalOperatorFromJSON(json['filterLogicalOperator']),
        'filterKeys': !exists(json, 'filterKeys') ? undefined : json['filterKeys'],
        'sortings': !exists(json, 'sortings') ? undefined : (json['sortings'] === null ? null : (json['sortings'] as Array<any>).map(SortingDtoFromJSON)),
    };
}

export function GetRolePermissionRelationsQueryToJSON(value?: GetRolePermissionRelationsQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissions': value.permissions,
        'roleId': value.roleId,
        'page': value.page,
        'pageSize': value.pageSize,
        'skip': value.skip,
        'take': value.take,
        'filterLogicalOperator': FilterLogicalOperatorToJSON(value.filterLogicalOperator),
        'filterKeys': value.filterKeys,
        'sortings': value.sortings === undefined ? undefined : (value.sortings === null ? null : (value.sortings as Array<any>).map(SortingDtoToJSON)),
    };
}


